export default __webpack_public_path__ + "5MHn9xn-right-arrow.svg";